import React from 'react';
import {Button} from 'reactstrap';

function PipelineFilter(props) {
	return (
		<Button color="warning" className={`fa fa-trash`}
			onClick={() => props.removeFilter(props.filter)}>
			{props.filter.Name}
		</Button>
	);
}

export default PipelineFilter;
